/**
 * Additional JS for sections/components
 */

class TilesRow extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      carousel: '[js-carousel]',
    }
  }
  
  connectedCallback() {
    this.$container = $(this)
    this.autoplayInterval = parseInt(this.dataset.autoplayInterval || 3000)
    $(document).ready(() => {
      this.initCarousel();
    });
  }

  initCarousel() {
    const mediaQuery = window.matchMedia('(max-width: 768px)')

    const init = () => {
      if (mediaQuery.matches) {
        this.$container.find(this.selectors.carousel).owlCarousel({ items: 1, autoplay: true, autoplayTimeout: this.autoplayInterval });
      } else {
        this.$container.find(this.selectors.carousel).trigger('destroy.owl.carousel');
      }
    }

    init();
    $(window).resize(init);	
  }
}

customElements.define('tiles-row', TilesRow);